import * as actions from './actions';

const initStateSporexpertUser = {
    count: 0,
    next: "",
    previous: "",
    loadingSporexpertuser: false,
    sporexpertuser: {},
    initialsporexpertuser: false,
    sucessSporexpertuser: false,
    errorSporexpertuser: false,
};

export function reducerSporexpertUser(state = initStateSporexpertUser, { type, ...action }) {
    switch (type) {
        case actions.SET_LOADING_SPOREXPERT_USER:
            return { ...state, loadingSporexpertuser: true };

        case actions.SET_SPOREXPERT_USER.SUCCESS: {
            const sporexpertuser_obj = action.sporexpertuser;

            return {
                ...state,
                loadingSporexpertuser: false,
                initialsporexpertuser: true,
                sporexpertuser: sporexpertuser_obj,
            };
        }

        // ----------------------------------------------------------------------

        case actions.UPDATE_SPOREXPERT_USER.REQUEST:
            return { ...state, loadingSporexpertuser: true };

        case actions.UPDATE_SPOREXPERT_USER.SUCCESS:

            return { ...state, loadingSporexpertuser: false, sucessSporexpertuser: 'Perfil guardado', initial: true, sporexpertuser: action.payload.sporexpertuser };

        case actions.UPDATE_SPOREXPERT_USER.FAILURE:
            return { ...state, loadingSporexpertuser: false, sucessSporexpertuser: false, errorSporexpertuser: action.payload.errorSporexpertuser };



        // ----------------------------------------------------------------------


        case actions.GET_SPOREXPERT_USER.SUCCESS: {
            const { results, count, next, previous } = action.sporexpertuser.data;

            return {
                ...state,
                loadingSporexpertuser: false,
                sporexpertuser: results,
                initialsporexpertuser: true,
            };
        }

        case actions.GET_SPOREXPERT_USER.FAILURE:
            return { ...initStateSporexpertUser };

        default:
            return state;
    }
}

